import { FormExtension } from './types';
import { RootState } from "../../rootReducers";
import { createBookingAsyncResponse } from "./types";
import * as bookingActions from "./actions";
import { ErrorResponse } from "../../../interfaces/Response";
import { put, call, takeEvery, select } from "redux-saga/effects";
import { apiPost, API_URL_BOOKING, retrieveToken } from "../../../helpers/api";

export function* createBooking(action: ReturnType<typeof bookingActions.createBookingAsync.request>) {
  try {
    const bookingFormExtension = (state: RootState) => state.booking.formExtension;
    const formExtension: FormExtension = yield select(bookingFormExtension);
    const token: string = yield retrieveToken();
    const bookingPayload = {...action.payload};
    let errors: any = {};

    if(bookingPayload.estimate_participant <= 0) {
      errors = {
        ...errors,
        estimate_participant: ["Jumlah peserta wajib diisi"]
      };
    }
    
    if (bookingPayload.start_date && formExtension.start_time) {
      bookingPayload.start_date = `${action.payload.start_date} ${formExtension.start_time?.value}` 
    } else {
      bookingPayload.start_date = ``;
      errors = {
        ...errors,
        start_date_time: ["Jam mulai kegiatan wajib diisi"]
      };
    }

    if (bookingPayload.start_date && formExtension.start_time) {
      bookingPayload.end_date = `${action.payload.start_date} ${formExtension.end_time?.value}`
    } else {
      bookingPayload.end_date = ``;
      errors = {
        ...errors,
        end_date_time: ["Jam selesai kegiatan wajib diisi"]
      };
    }

    if (Object.keys(errors).length > 0) {
      yield put(bookingActions.createBookingAsync.failure({ 
        status: 402,
        message: 'Form wajib diisi lengkap',
        errors: {...errors}
      }));
      return;
    }

    const result: Response = yield call(apiPost, API_URL_BOOKING.CREATE_BOOKING, token, bookingPayload);
    if (result.status === 200) {
      const parsed: createBookingAsyncResponse = yield call(result.json.bind(result));
      yield put(bookingActions.createBookingAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bookingActions.createBookingAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(bookingActions.createBookingAsync.failure(parsed));
  }
}

export default function* bookingsSagaCreateBooking() {
  yield takeEvery(bookingActions.createBookingAsync.request, createBooking);
}
